
export const SHOW_SETTINGS = 'SHOW_SETTINGS'

export const SETTINGS_EXPORT_KEY = 'SETTINGS_EXPORT_KEY'
export const SETTINGS_IMPORT_KEY = 'SETTINGS_IMPORT_KEY'
export const SETTINGS_IMPORT_PARTNER_KEYCERT = 'SETTINGS_IMPORT_PARTNER_KEYCERT'
export const SETTINGS_CLEAR_CACHE = 'SETTINGS_CLEAR_CACHE'
export const SETTINGS_IN_PROCESS = 'SETTINGS_IN_PROCESS'

export const SETTINGS_CHANGE_PASSWORD = 'SETTINGS_CHANGE_PASSWORD'
export const SETTINGS_REVOKE_KEY = 'SETTINGS_REVOKE_KEY'

export const SHOW_CONFIRM_DIALOG = 'SHOW_CONFIRM_DIALOG'

export const displaySettings = ( boolean ) => ({
	type: SHOW_SETTINGS,
	payload : boolean
})

export const exportKey = () => ({
	type: SETTINGS_EXPORT_KEY
})

export const importKey = () => ({
	type: SETTINGS_IMPORT_KEY
})

export const importPartnerKeyCert = () => ({
	type: SETTINGS_IMPORT_PARTNER_KEYCERT
})

export const changePassword = () => ({
	type: SETTINGS_CHANGE_PASSWORD
})

export const clearCache = () => ({
	type: SETTINGS_CLEAR_CACHE
})

export const revokeKey = () => ({
	type: SETTINGS_REVOKE_KEY
})

export const settingsInProcess = ( show, msg ) => ({
  type: SETTINGS_IN_PROCESS,
  payload: { show: show, msg: msg }
})

export const showConfirmDialog = ( boolean ) =>({
	type : SHOW_CONFIRM_DIALOG,
	payload : { boolean }
})

const initialState = {
	showSettings : true,
	settingsInProcess: {
				show: false,
				msg: ""
			}
}

export const settingsReducer = ( state = initialState, { type, payload }) => {
	switch(type){
		case SHOW_SETTINGS : {
			console.log("In settingsReducer SHOW_SETTINGS " + payload)
			return { ...state, showSettings: payload }
		}
		case SETTINGS_IN_PROCESS: {
			return { ...state, settingsInProcess: payload }
		}
		case SHOW_CONFIRM_DIALOG: {
			return { ...state, confirmDialog: payload.boolean }
		}
		default:
			return state
	}
}
